import { api } from '@/apis';
import { log } from '@/utils';
import { useQuery, useQueryClient } from '@tanstack/react-query';

export function useTeamVehicles(groupCodes = []) {
  const queryKey = ['vehicles', groupCodes];
  const queryClient = useQueryClient();
  const query = useQuery({
    queryKey,
    queryFn: async ({ signal }) => {
      const json = [
        {
          $match: {
            groupCodes: { $in: groupCodes },
            $or: [
              { disposalDate: { $exists: false } },
              { disposalDate: { $gt: new Date() } },
            ],
          },
        },
        {
          $lookup: {
            from: 'vehicleStates',
            localField: 'identificationNumber',
            foreignField: 'identificationNumber',
            pipeline: [
              { $match: { type: 'Check' } },
              { $sort: { time: -1 } },
              { $limit: 1 },
              { $project: { _id: false, time: true } },
            ],
            as: 'lastCheck',
          },
        },
        {
          $project: {
            _id: false,
            identificationNumber: '$identificationNumber',
            fleetNumber: '$fleetNumber',
            registrationNumber: '$registrationNumber',
            role: '$role',
            type: '$type',
            make: '$make',
            model: '$model',
            keyNumber: '$keyNumber',
            colour: '$colour',
            isMarked: '$marked',
            imei: '$telematicsBoxImei',
            driver: {
              $switch: {
                branches: [
                  {
                    case: {
                      $not: {
                        $setIsSubset: [
                          ['$driver.identificationReference'],
                          [null, ''],
                        ],
                      },
                    },
                    then: {
                      code: '$driver.code',
                      forenames: '$driver.forenames',
                      surname: '$driver.surname',
                      collarNumber: '$driver.collarNumber',
                      identificationReference:
                        '$driver.identificationReference',
                      isCurrent: true,
                    },
                  },
                  {
                    case: {
                      $not: {
                        $setIsSubset: [
                          ['$lastDriver.identificationReference'],
                          [null, ''],
                        ],
                      },
                    },
                    then: {
                      code: '$lastDriver.code',
                      forenames: '$lastDriver.forenames',
                      surname: '$lastDriver.surname',
                      collarNumber: '$lastDriver.collarNumber',
                      identificationReference:
                        '$lastDriver.identificationReference',
                      isCurrent: false,
                    },
                  },
                ],
                default: null,
              },
            },
            lastCheckTime: { $first: '$lastCheck.time' },
            notes: '$notes',
            lastIgnitionOffTime: '$lastIgnitionOffTime',
          },
        },
      ];

      log('Read', 'Team Vehicles', { groupCodes });

      return api.post('pipeline/vehicles', { json, signal }).json();
    },
    placeholderData: [],
    staleTime: 1000 * 60 * 60,
  });

  return {
    ...query,
    cancel: () => queryClient.cancelQueries({ queryKey }),
  };
}
